export default {
  text_1_1: 'Sauvegarder n’a jamais été aussi simple et sûr.',
  text_1_2: 'Des options avancées pour répondre à vos besoins de confidentialité.',
  text_2_1: 'Durable, portable et résistant à la flexion.',
  text_2_2: 'Sécurisé par CC EAL6+',
  text_2_3: 'Puce — à emporter partout avec vous.',
  text_2_4: 'Résistant à la flexion, antimagnétique et antistatique.',
  text_2_5: 'Prend en charge jusqu’à 500 000 passages de carte.',
  text_3_1:
    'Propulsé par TokenPocket, profitez d’une expérience utilisateur parfaite lors de l’utilisation de la KeyPal Card.',
  text_4_1: 'Code PIN pris en charge pour renforcer la sécurité',
  text_4_2:
    'La carte sera automatiquement effacée après dix tentatives consécutives de PIN erroné.',
  text_4_3: 'Pas seulement pour la sauvegarde, mais aussi pour la signature',
  text_4_4:
    'La polyvalence de la carte dépasse la sauvegarde : elle sert aussi de composant essentiel pour la signature des transactions.',
  text_4_5: 'NFC, sauvegarde en un geste : simple et sûre.',
  text_4_6: 'Activez un chiffrement bidirectionnel rapide via les champs électromagnétiques pour des sauvegardes rapides et simples.',
  text_5_1: 'Il est temps de commencer avec votre',
  text_6_1: 'Portefeuille',
  text_6_2:
    'Intégration transparente pour une expérience de portefeuille inégalée où chaque KeyPal Card se connecte !',
  text_6_3: 'Sauvegarde',
  text_6_4:
    'Rendez la sauvegarde de votre portefeuille simple et sûre, en éliminant les pertes d’actifs dues à des sauvegardes erronées.',
  text_6_5: 'Signature',
  text_6_6:
    'Débloquez des usages variés du portefeuille avec votre KeyPal Card, et signez chaque opération en toute simplicité.',
};
